import React, { Component } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import global from '../../global';
import { observer } from 'mobx-react';

const Sidebar = observer(class Sidebar extends Component {

  constructor(props) {
    super(props);
  }

  handleCloseSidebar(e) {
    global.closeSidebar();
  }

  render() {
    return (
      <div className="sidebar">
        <div className="sidebar-item sidebar-footer">
        </div>
        <nav className="sidebar-nav">
          <Link to="/home" className="sidebar-nav-item" onClick={this.handleCloseSidebar} activeClassName="active">Home</Link>
          <Link to="/portfolio" className="sidebar-nav-item" onClick={this.handleCloseSidebar} activeClassName="active">Works</Link>
          <Link to="/services" className="sidebar-nav-item" onClick={this.handleCloseSidebar} activeClassName="active">Services</Link>
          <Link to="/about" className="sidebar-nav-item" onClick={this.handleCloseSidebar} activeClassName="active">About</Link>
        </nav>

        <div className="sidebar-item sidebar-footer">
          <p>
            Here's a link to my 	<Link to="/cv" onClick={this.handleCloseSidebar}>CV</Link><br /><br />
            {/* Check <a href="https://teamtreehouse.com/malkiokusanagi" target="_blank">Team Treehouse</a><br/> */}
            Check <a href="https://www.freecodecamp.com/malkio">Code Camper</a><br /><br />
            Visit <a href="https://github.com/malkio" target="_blank">My GitHub Repo</a><br />
            {/* Visit <a href="https://codepen.io/malkio/">Codepen</a><br/> */}
            {/* Visit <a href="https://www.facebook.com/malkio47" target="_blank">Facebook</a><br /> */}
          </p>
          <p>
          </p>
        </div>
      </div>
    );
  }
})

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/layout/Sidebar.js